import FloatingFormItem from '@/components/_common/FloatingFormItem';
import InputDecimal from '@/components/_common/InputDecimal';
import { Row, Col, Form, Checkbox } from 'antd';
import { useLabelPrintingContext } from '../..';

export default function LabelPrintingToolbarCardPanel() {
  const { form } = useLabelPrintingContext();
  const heightAuto = Form.useWatch(['layout', 'heightAuto'], form);
  const oneCardPerPage = Form.useWatch(['layout', 'oneCardPerPage'], form);

  return (
    <>
      <Row gutter={[16, 0]}>
        <Col span={24}>
          <Form.Item
            name={['layout', 'withCardBorder']}
            valuePropName="checked"
            style={{ margin: 0 }}
          >
            <Checkbox>Aplicar borda no card</Checkbox>
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name={['layout', 'heightAuto']}
            valuePropName="checked"
            style={{ margin: 0 }}
          >
            <Checkbox disabled={oneCardPerPage}>
              Altura do card automática
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={24}>
          <FloatingFormItem
            name={['layout', 'cardHeight']}
            label="Altura do card"
          >
            <InputDecimal
              style={{ width: '100%' }}
              min={0}
              disabled={heightAuto || oneCardPerPage}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </>
  );
}
